import { useSelector } from 'react-redux';

export const useActivePermission = () => {
  return useSelector(state => state.auth.activePermission);
};

export default useActivePermission;